export default __webpack_public_path__ + "static/media/ruby.1a74e7a3.png";